import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useRef, useState, useMemo, useId, Children, isValidElement, cloneElement, } from "react";
import { classes } from "../utils/classes";
import { mutableDOMRect } from "../utils/dom";
var Tooltip = function (props) {
    var text = props.text, children = props.children, fontSize = props.fontSize, maxWidth = props.maxWidth;
    var id = useId();
    var tooltipRef = useRef(null);
    var _a = useState(false), show = _a[0], setShow = _a[1];
    var _b = useState({ top: 0, left: 0 }), position = _b[0], setPosition = _b[1];
    var _c = useState(false), above = _c[0], setAbove = _c[1];
    var _d = useState(), triangleMargin = _d[0], setTriangleMargin = _d[1];
    // On hover, compute position of tooltip and show it
    var handleEnter = useCallback(function (e) {
        var _a;
        if (!tooltipRef.current)
            return;
        var target = e.currentTarget;
        var rect = mutableDOMRect(target.getBoundingClientRect());
        var offsetRect = (_a = target.offsetParent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (offsetRect) {
            rect.top -= offsetRect.top;
            rect.bottom -= offsetRect.top;
            rect.left -= offsetRect.left;
            rect.right -= offsetRect.left;
        }
        var tooltipRect = tooltipRef.current.getBoundingClientRect();
        if (rect.right + tooltipRect.width > window.innerWidth) {
            // If the tooltip box is past the right edge of the page, position it to the top
            setAbove(true);
            setPosition({
                top: rect.top - rect.height / 2 - tooltipRect.height,
                left: window.innerWidth / 2 - tooltipRect.width / 2,
            });
            // Calculate margin so triangle will be pointing to info icon
            setTriangleMargin("0 ".concat(window.innerWidth / 2 - rect.right + 5, "px 0 0"));
        }
        else {
            // Position tooltip to the left
            setAbove(false);
            setPosition({
                top: rect.top + rect.height / 2 - tooltipRect.height / 2,
                left: rect.right + 10,
            });
            // Have the triangle be in the center of the tooltip
            setTriangleMargin("-5px 0 0");
        }
        setShow(true);
    }, []);
    // Compute the style of the tooltip
    var style = useMemo(function () { return ({
        opacity: show ? 1 : 0,
        top: position.top,
        left: position.left,
        maxWidth: maxWidth,
        fontSize: fontSize,
    }); }, [show, position, maxWidth, fontSize]);
    // Add event listeners + refs to the children to show/hide tooltip
    var childrenWithProps = useMemo(function () {
        return Children.map(children, function (child) {
            if (!isValidElement(child))
                return child;
            return cloneElement(child, {
                onMouseEnter: handleEnter,
                onFocus: handleEnter,
                onMouseLeave: function () { return setShow(false); },
                onBlur: function () { return setShow(false); },
                "aria-describedby": id,
            });
        });
    }, [children, handleEnter, id]);
    return (_jsxs(_Fragment, { children: [childrenWithProps, _jsxs("div", { className: "pointer-events-none fixed z-10 w-max rounded-lg bg-black/50 p-2 shadow-lg backdrop-blur-sm transition-opacity", ref: tooltipRef, style: style, id: id, role: "tooltip", children: [_jsx("div", { className: classes("absolute border-[5px] border-solid border-transparent", above
                            ? "top-full right-1/2 border-t-black/50"
                            : "top-1/2 right-full border-r-black/50"), style: { margin: triangleMargin } }), text] })] }));
};
export default Tooltip;
